var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.189,
    height: 18,
    viewBox: "0 0 18.189 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_refresh",
    "data-name": "icona refresh",
    transform: "translate(-106 -86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_refresh-2",
    "data-name": "icona refresh",
    transform: "translate(107 88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_108",
    "data-name": "Tracciato 108",
    d: "M29.918,6v4.389H25.5",
    transform: "translate(-13.718 -5.27)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_109",
    "data-name": "Tracciato 109",
    d: "M1.5,25.389V21H5.918",
    transform: "translate(-1.5 -12.956)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_110",
    "data-name": "Tracciato 110",
    d: "M3.348,8.89A6.647,6.647,0,0,1,14.283,6.433L17.7,9.622M1.5,12.547l3.417,3.189a6.647,6.647,0,0,0,10.935-2.458",
    transform: "translate(-1.5 -4.503)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_787",
    "data-name": "Rettangolo 787",
    transform: "translate(106 86)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.53651f323b1e8c44d20831e29cce0aea.svg";
export { ForwardRef as ReactComponent };